const CELL_VALUE = (index, { _data: data }) => data[index];

export default CELL_VALUE;
